var classes = {"root":"oz7PS"};

export { classes as default };
